<template>
<v-card>

  <camera-thumb :src="imageUrl" :faces="faces" clickable @click="onImageClick"></camera-thumb>

  <v-layout row class="pa-0 ma-0">

    <v-flex grow>
      <v-list class="py-0 my-0">
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>{{device.hostname}} {{this.device.targetName || this.device.name}}</v-list-tile-title>
            <v-list-tile-sub-title>{{timestamp}}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-flex>

    <v-flex shrink>

      <v-btn icon @click="$emit('setting',device)" :disabled="loading" class="hidden-xs-only">
        <v-icon v-if="device.trigger" color="red">settings_remote</v-icon>
        <v-icon v-else color="primary">settings</v-icon>
      </v-btn>

      <v-btn icon @click="refresh" :loading="loading" class="hidden-xs-only">
        <v-icon color="primary">refresh</v-icon>
      </v-btn>

      <v-menu class="hidden-sm-and-up" :disabled="loading">
        <v-btn icon slot="activator" :loading="loading">
          <v-icon color="grey">more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="$emit('setting',device)">
            <v-list-tile-action>
              <v-icon v-if="device.trigger" color="red">settings_remote</v-icon>
              <v-icon v-else color="primary">settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>{{ $t('camera.setting') }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="refresh">
            <v-list-tile-action>
              <v-icon color="primary">refresh</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>{{ $t('camera.refresh') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

    </v-flex>

  </v-layout>

</v-card>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import CameraThumb from './CameraThumb'

export default {
  name: 'CameraItem',
  mixins: [UserAuth],
  props: {
    device: {
      type: Object,
      required: true
    },
    faceReference: {
      type: Object
    }
  },
  components: {
    'camera-thumb': CameraThumb
  },
  data() {
    return {
      shot: {},
      imageUrl: undefined,
      loading: false,
      dialog: false,
      faces: null
    }
  },
  computed: {
    refShot() {
      return this.$db.ref('userShot').child(this.userId).child(this.device.key);
    },
    timestamp() {
      if (this.shot && this.shot.timestamp)
        return new Date(this.shot.timestamp).toLocaleString();
      return '';
    }
  },
  watch: {
    shot(val) {
      this.imageUrl = '';
      let fs = null;
      if (val) {
        this.imageUrl = `${val.url}&${val.timestamp}`;
        let result = val.result || {};
        if (result.FaceDetails) {
          fs = result.FaceDetails;
          if (result.FaceMatches) {
            let firstMatch = result.FaceMatches.map(fm => fm.Face).find(f => f);
            if (firstMatch && fs.length > 0) {
              fs[0].FaceId = firstMatch.FaceId;
              fs[0].Confidence = firstMatch.Confidence;
              if (this.faceReference) {
                fs[0].Name = (this.faceReference[firstMatch.FaceId] || {}).Name;
              }
            }
          }
        }
      }
      this.faces = fs;
      this.loading = false;
    }
  },
  methods: {
    refresh() {
      this.loading = true;
      let cmd = {
        user: this.userId,
        mac: this.device.mac,
        uid: this.device.uid,
        cmd: 'snapshot',
        faceDetection: true,
        faceMatching: this.userId
      };
      this.$db.ref('command/cast').push().set(cmd).catch(err => console.log(err.message));
    },
    onImageClick() {
      if (this.imageUrl && !this.loading) {
        this.$emit('fullscreen', this.imageUrl)
      }
    }
  },
  mounted() {
    this.refShot.off();
    this.refShot.on('value', snapshot => {
      this.shot = snapshot.val();
    });
  },
  beforeDestroy() {
    this.refShot.off();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cast/CameraItem.vue